
<template>
  <div class="mt-8 max-w-5xl mx-auto px-4 pb-12 sm:px-6 lg:px-8">
    <div class="mt-1 grid grid-cols-1 gap-4">
      <Link
        :data="{
          search: $page.props.filters.search,
          page: $page.props.equipmentCalibrations.meta.current_page,
        }"
        :href="
          route('equipment.equipment-calibrations.create', {
            equipment: equipment.data.id,
          })
        "
        class="
          cursor-pointer
          relative
          rounded-lg
          border border-gray-300
          bg-white
          px-6
          py-5
          shadow-sm
          flex
          items-center
          space-x-3
          hover:border-green-500
          focus-within:ring-2
          focus-within:ring-offset-2
          focus-within:ring-green-500
        "
      >
        <div class="flex-shrink-0">
          <PlusCircleIcon class="w-10 h-10 text-green-500" />
        </div>
        <div class="flex-1 min-w-0">
          <div class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900">{{ t("add") }}</p>
            <p class="text-sm text-gray-500 truncate">
              {{ t("new_calibration") }}
            </p>
          </div>
        </div>
      </Link>
      <Link
        :data="{
          search: $page.props.filters.search,
          page: $page.props.equipmentCalibrations.meta.current_page,
        }"
        :href="
          route('equipment-calibrations.edit', {
            equipment_calibration: equipmentCalibration.id,
          })
        "
        v-for="equipmentCalibration in equipmentCalibrations.data"
        :key="equipmentCalibration.id"
        class="
          relative
          rounded-lg
          border border-gray-300
          bg-white
          px-6
          py-5
          shadow-sm
          flex
          items-center
          space-x-3
          hover:border-gray-400
          focus-within:ring-2
          focus-within:ring-offset-2
          focus-within:ring-light-blue-500
        "
      >
        <div class="flex-1 min-w-0">
          <a href="#" class="focus:outline-none">
            <span class="absolute inset-0" aria-hidden="true"></span>
            <p class="text-sm font-medium text-gray-900 truncate">
              {{ equipmentCalibration.formatted_calibrated_on }}
              <span class="text-sm text-gray-500 truncate">
                {{ equipmentCalibration.user.name }}
              </span>
            </p>
            <p class="text-sm text-gray-500 truncate">
              {{ equipmentCalibration.comments }}
            </p>
          </a>
        </div>
      </Link>
    </div>
    <pagination
      v-show="equipmentCalibrations.data.length > 0"
      :data="{ search: $page.props.filters.search }"
      class="py-3 md:px-0"
      :pagination="equipmentCalibrations"
    />
  </div>
</template>

<script>
import Pagination from "../../Shared/Molecules/Pagination";
import { useI18n } from "vue-i18n";
import { PlusCircleIcon } from "@heroicons/vue/outline";

export default {
  components: {
    Pagination,
    PlusCircleIcon,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    equipment: { type: Object, required: true },

    equipmentCalibrations: { type: Object, required: true },
  },
};
</script>

<i18n>
{
  "es": {
    "add": "Agregar",
    "new_calibration": "Nueva calibración"
  }
}
</i18n>
